import React from "react";
import i18next from "i18next";
import { useDrawingContext } from "../../Contexts/DrawingContext";
import { useMapContext } from "../../Contexts/MapContext";
import { AccordionItem } from "../../Elements/Accordion";
import { Colors } from "./Colors";
import { DrawingToolbar } from "./DrawingToolbar";
import { DrawnItems } from "./DrawnItems";

export const Draw = (): JSX.Element => {
    const { drawType } = useMapContext();
    const { colorsVisible, setColor } = useDrawingContext();

    return (
        <AccordionItem
            title={i18next.t("sketch.drawingTools")}
            changeHeight={Math.random()}
            key="drawGeometries"
            class="drawing-accordion"
        >
            <DrawingToolbar />
            {colorsVisible ? <Colors onChange={(color) => setColor(color.hex)} disabled={!!drawType} /> : null}
            <DrawnItems />
        </AccordionItem>
    );
};
